export type QueryParameterValue =
  | string
  | number
  | boolean
  | Array<string | number | boolean | undefined | null>
  | undefined
  | null;

export const createQueryString = (query: object = {}) => {
  const parameters = new URLSearchParams();

  for (const [key, value] of Object.entries(query) as Array<
    [string, QueryParameterValue]
  >) {
    if (value === undefined || value === null) continue;

    if (Array.isArray(value)) {
      for (const item of value) {
        if (item !== undefined && item !== null) {
          parameters.append(key, String(item));
        }
      }

      continue;
    }

    parameters.set(key, String(value));
  }

  return parameters.toString();
};

export const buildUrlFromPathAndQuery = (
  pathname: string,
  query: object = {}
) => {
  const queryString = createQueryString(query);

  return queryString ? `${pathname}?${queryString}` : pathname;
};
